






































































import { Component, Vue } from 'vue-property-decorator'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import { formatDate } from '@/utils/tool'
import { BaseStore } from '@/store/modules/Base'
import { UserStore, userInfoTypes } from '@/store/modules/User'
// import SearchInput from '@/components/SearchInput/index.vue'
import CityIndexSearchBox from '@/components/CityIndexSearchBox/index.vue'
import ProductList from '@/components/ProductList/index.vue'
import Introduction from '../components/Introduction.vue'

import { getMchUserInfo, custProductTypies } from '@/api/com'
import { weekHot, hotSale } from '@/api/product'

@Component({
  name: 'Merchant',
  components: {
    Introduction,
    swiper: Swiper,
    'swiper-slide': SwiperSlide,
    // SearchInput,
    CityIndexSearchBox,
    ProductList
  },
  directives: {
    swiper: directive
  },
  beforeRouteLeave (to, from, next) {
    BaseStore.SET_CLIENT_INFO()
    next()
  }
})
export default class Merchant extends Vue {
  private loading = false;

  // 商户ID 如果路由上有带ID过来
  private id = '';

  // 商户ID 如果路由上有带 dbLink
  private saas = '';

  // 轮播图
  private swiperOptions = {
    loopedSlides: 6,
    slidesPerView: 'auto', // 显示数量
    spaceBetween: 10,
    observer: true, // 修改swiper自己或子元素时，自动初始化swiper
    observeParents: true, // 修改swiper的父元素时，自动初始化swiper
    // loop: true, // 循环模式选项
    speed: 500,
    autoplay: {
      delay: 1500,
      stopOnLastSlide: false,
      disableOnInteraction: true
    },
    // 如果需要前进后退按钮
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  };

  // 产品分类初始数据
  private productClassList: any[] = []

  // 热销产品
  private hotList = [];

  // 页数
  private page = 1;

  // 每页多少条数据
  private resultNum = 10;

  private keywords = '';

  private treeId = '';

  private areaId: number | string = ''

  // 数据总数
  private sizeAll = 0;

  // 爆款
  private fieryList = [];

  readonly treeIdName = {
    0: '门票',
    1: '套餐',
    2: '自由行',
    3: '线路',
    4: '演出',
    5: '住宿',
    6: '服务',
    7: '租车',
    8: '签证',
    9: '邮轮',
    10: '机票',
    11: '商品',
    12: '抢购',
    13: '租车（新）',
    14: '交通',
    15: '场馆',
    16: '培训课程',
    17: '户外装备',
    18: 'OMO服务'
  };

  get userInfo (): userInfoTypes {
    return UserStore.userInfo
  }

  get info () {
    if (this.id) {
      return BaseStore.clientInfo
    }
    return UserStore.userInfo
  }

  changeSearch () {
    this.getHotSale(true)
  }

  // 类别切换
  changeType (item): void {
    this.treeId = item
    this.getHotSale(true)
  }

  // 切换城市
  changeCity (item: number): void {
    this.areaId = item
    this.getHotSale(true)
  }

  // currentPage 改变时会触发
  currentChange (e: number): void {
    this.page = e
    const scrollWrapper: any = this.$refs.scrollWrapper
    scrollWrapper.scrollIntoView()
    this.getHotSale(false)
  }

  // 获取商户信息
  getMchUserInfo () {
    getMchUserInfo(this.saas, this.id).then(res => {
      if (res) {
        BaseStore.SET_CLIENT_INFO(res)
      }
    })
  }

  // 获取产品类型-分类 treeId
  getCustProductTypies ():void {
    custProductTypies()
      .then((res: any) => {
        if (res) {
          const arr: any[] = res || []
          arr.unshift({
            id: 99,
            name: '全部'
          })
          this.productClassList = arr
        }
      })
  }

  // 获取 他/我 的爆款
  getWeekHot () {
    const params = {
      parentMchId: Number(this.id)
    }
    weekHot(params).then(res => {
      console.log('的爆款')
      console.log(res)
      if (res) {
        const arr = res || []
        this.fieryList = arr.map(item => {
          if (item.treeId === 12) {
            item.treeIdNameColor = 'linear-gradient(90deg, #FA6D0F, #F73434)'
          }
          item.treeIdName = this.treeIdName[item.treeId]
          item.star = item.systemGrade / 2
          item.priceStartDateStr = formatDate(item.priceStartDate, 'Y-M-D')
          item.priceEndDateStr = formatDate(item.priceEndDate, 'Y-M-D')
          // 处理 产品绑定关系
          if (item.refStatus === 3) {
            // 可操作 绑定关系
            item.btnClassName = 'list_3'
          } else if (item.refStatus === 0 && item.cmProdLog) {
            // 可操作 取消引用
            item.btnClassName = 'list_2'
          } else if (item.refStatus === 0 && !item.cmProdLog) {
            // 可操作 引用产品
            item.btnClassName = 'list_1'
          }

          return item
        })
      }
    })
  }

  // 获取热销产品
  getHotSale (autoCount?: boolean) {
    this.loading = true
    const params = {
      areaId: this.areaId,
      autoCount: autoCount || false,
      keywords: this.keywords,
      resultNum: this.resultNum,
      page: this.page,
      treeId: this.treeId,
      parentMchId: this.id,
      dbLink: this.saas
    }
    hotSale(params).then(res => {
      this.loading = false
      if (res) {
        if (autoCount) this.sizeAll = res.sizeAll
        this.hotList = res.results || []
      }
    })
  }

  mounted (): void {
    const { saas, id } = this.$route.params
    this.id = id
    this.saas = saas
    this.getMchUserInfo()
    this.getWeekHot()
    this.getHotSale(true)
    this.getCustProductTypies()
  }
}
